module.exports = __webpack_public_path__ + "img/yzgh.e7762a10.jpg";